import React from "react";
import { IContactComposition } from "../../interfaces/IContact";
import {
  Section,
  Inputs,
  Group,
  Input,
  TextArea,
  Submit,
  Item,
  Title,
  Desc,
  MediaContainer,
  MediaLink,
  MediaIcon,
  Pane,
} from "./styles/Contact";

const Contact: React.FC & IContactComposition = ({
  children,
  ...restProps
}) => <Section {...restProps}>{children}</Section>;

Contact.Form = function ContactForm({ children, ...restProps }) {
  return <Pane {...restProps}>{children}</Pane>;
};

Contact.Inputs = function ContactInputs({ children, ...restProps }) {
  return <Inputs {...restProps}>{children}</Inputs>;
};

Contact.Group = function ContactGroup({ children, ...restProps }) {
  return <Group {...restProps}>{children}</Group>;
};

Contact.Input = function ContactInput({ children, ...restProps }) {
  return (
    <Input type='text' required {...restProps}>
      {children}
    </Input>
  );
};

Contact.TextArea = function ContactTextArea({ children, ...restProps }) {
  return (
    <TextArea required {...restProps}>
      {children}
    </TextArea>
  );
};

Contact.Submit = function ContactSubmit({ children, ...restProps }) {
  return <Submit {...restProps}>{children}</Submit>;
};

Contact.Infos = function ContactInfos({ children, ...restProps }) {
  return <Pane {...restProps}>{children}</Pane>;
};

Contact.Item = function ContactItem({ children, ...restProps }) {
  return <Item {...restProps}>{children}</Item>;
};

Contact.Title = function ContactTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Contact.Desc = function ContactDesc({ children, ...restProps }) {
  return <Desc {...restProps}>{children}</Desc>;
};

Contact.MediaContainer = function ContactMediaContainer({
  children,
  ...restProps
}) {
  return <MediaContainer {...restProps}>{children}</MediaContainer>;
};

Contact.MediaLink = function ContactMediaLink({
  icon,
  to,
  children,
  ...restProps
}) {
  return (
    <MediaLink href={to} {...restProps}>
      <MediaIcon className={icon} />
    </MediaLink>
  );
};

export default Contact;
